import React, { useContext } from 'react';
import DataGrid from '../../../../../components/DataGrid/DataGrid';
import { localText } from '../../../../../langs/fa/data-grid';
import { Store } from './Provider';
import moment from 'moment-jalaali';
import { formatNumber } from 'fns';
import Button from '@material-ui/core/Button';
import { __ } from 'utils/i18n';

const List = () => {
  const {
    state: { basePrices, inProgress, itemsCountPerPage },
    dispatch,
    actions: { showMessage, showError, deleteBasePrice },
  } = useContext(Store);
  const columns = [
    {
      field: 'date',
      headerName: 'تاریخ',
      width: 100,
      renderCell: ({ value: { date } }) => moment(date).format('jYY/jMM/jDD'),
    },
    {
      field: 'origin',
      headerName: 'مبدا',
      width: 100,
      renderCell: ({ value: { origin } }) => origin.title,
    },
    {
      field: 'fleetOptions',
      headerName: 'نوع ناوگان',
      flex: 1,
      renderCell: ({ value: { fleetOptions } }) =>
        fleetOptions.map((f) => `${f.fleet.title}(${f.title})`).join('، '),
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
      renderCell: ({ value: { destination } }) => destination.title,
    },
    {
      field: 'basePrice',
      headerName: 'کرایه حمل',
      flex: 1,
      renderCell: ({ value: { basePrice } }) => formatNumber(basePrice),
    },
    {
      field: 'cargoType',
      headerName: 'ماهیت بار',
      flex: 1,
      renderCell: ({ value: { cargoType } }) =>
        `${__(cargoType?.[0])} ${
          cargoType?.[1] ? `- ${__(cargoType?.[1])}` : ''
        }`,
    },
    {
      field: 'delete',
      headerName: 'حذف    ',
      width: 100,
      renderCell: ({ value }) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleDeleteBasePrice(value._id)}
        >
          حذف
        </Button>
      ),
    },
  ];

  const handleSelectBasePrice = ({ row, field }) => {
    const basePrice = basePrices?.docs?.find(
      (basePrice) => basePrice._id === row.id
    );
    dispatch({
      type: 'SET',
      payload: {
        origin: {
          label: basePrice?.origin?.title,
          value: basePrice?.origin?._id,
        },
        destination: {
          label: basePrice?.destination?.title,
          value: basePrice?.destination?._id,
        },
        fleetOptions: basePrice?.fleetOptions,
        date: basePrice?.date,
        basePrice: basePrice?.basePrice,
        legalLoad: basePrice?.cargoType,
      },
    });
  };
  const handlePageChange = (page) => {
    dispatch({ type: 'PAGE', payload: page });
  };
  const handleDeleteBasePrice = async (id) => {
    deleteBasePrice(id);
  };

  return (
    <div style={{ height: 300 }}>
      <DataGrid
        rows={
          basePrices?.docs?.map
            ? basePrices.docs.map((basePrice) => ({
                id: basePrice._id,
                date: basePrice,
                origin: basePrice,
                fleetOptions: basePrice,
                destination: basePrice,
                basePrice: basePrice,
                cargoType: basePrice,
                delete: basePrice,
              }))
            : []
        }
        columns={columns}
        localeText={localText}
        pageSize={itemsCountPerPage}
        rowCount={basePrices?.totalDocs || 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={inProgress}
        disableMultipleSelection
        onCellClick={handleSelectBasePrice}
        density="compact"
      />
    </div>
  );
};

export default React.memo(List);
